/**
 * La fenêtre d'acquisition d'un objet de la boutique, côté app.
 *
 * Miroir exact de `public.shop_item_obtainable` en base. Le serveur reste le
 * seul juge (il refuse l'achat et filtre les coffres) ; cette copie sert à ne
 * rien PROPOSER qui serait refusé, et à ne rien débiter pour rien.
 *
 * Un objet Halloween 26 porte `released_at` = 10/10 et `available_until` =
 * 06/11 : on peut l'obtenir à partir du 10/10 inclus, et plus à partir du 06/11
 * pile. La fin est exclue, comme en base.
 */
export interface AcquisitionWindow {
  released_at?: string | null
  available_until?: string | null
}

const parse = (iso: string | null | undefined): number | null => {
  if (!iso) return null
  const t = Date.parse(iso)
  return Number.isNaN(t) ? null : t
}

/** L'objet n'a pas encore ouvert sa fenêtre. */
export function notYetOpen(item: AcquisitionWindow, at: number = Date.now()): boolean {
  const released = parse(item.released_at)
  return released !== null && released > at
}

/** L'objet a refermé sa fenêtre. */
export function alreadyClosed(item: AcquisitionWindow, at: number = Date.now()): boolean {
  const until = parse(item.available_until)
  return until !== null && until <= at
}

/** L'objet peut être obtenu à cet instant, par achat comme par coffre. */
export function isObtainable(item: AcquisitionWindow, at: number = Date.now()): boolean {
  return !notYetOpen(item, at) && !alreadyClosed(item, at)
}
